var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_BORK/lorem/index.js
// module id = 752
// module chunks = 0